import styled, { css } from "styled-components";
import { theme } from "@Styled";

export interface IBar {
    percent: number;
    isUserChoice: boolean;
}

const userChoiceBackground = {
    background: theme.palette.common.tbCyan,
};
const defaultChoiceBackground = {
    background: theme.palette.common.lightGray,
};

export const StyledBar = styled.div<IBar>(({ percent, isUserChoice }) => {
    return css`
        position: absolute;
        transition: 0.5s;
        border-radius: 10px;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        font-weight: "lighter";
        pointer-events: none;
        width: ${percent ? `${percent}%` : 0};
        ${isUserChoice ? userChoiceBackground : defaultChoiceBackground};
        font-weight: ${isUserChoice ? "bolder" : "lighter"};
    `;
});
